import { render, staticRenderFns } from "./vendors_active.vue?vue&type=template&id=3fa288f6&lang=pug"
import script from "./vendors_active.vue?vue&type=script&lang=js"
export * from "./vendors_active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports